export default "__VITE_ASSET__7L1F9UZ5__"